function e(e){const t=Object.keys(e)||[];if(t.length<1)return"";return t.reduce(((n,r,s)=>n+=`.setTargeting('${r}', '${e[r]}')${s===t.length-1?";":""}`),"slot")}export{e as default};
